import 'bootstrap/dist/css/bootstrap.css'
// Self-hosted Font Awesome Free 7.3.1 (see src/assets/fontawesome/LICENSE.txt).
// Replaces the former kit.fontawesome.com script in public/index.html.
// v4-shims provides the legacy `fa fa-*` aliases still used by GrapesJS and older markup.
import './assets/fontawesome/css/fontawesome.css'
import './assets/fontawesome/css/solid.css'
import './assets/fontawesome/css/regular.css'
import './assets/fontawesome/css/v4-shims.css'
import React, { Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import AppWrapper from './app/AppWrapper'
import { store } from './app/store'
import ScrollToTop from './components/ui/ScrollToTop'
import { BlastProvider } from './providers/blast/BlastProvider'
import { EnvironmentProvider } from './providers/environment/EnvironmentProvider'
import { SessionProvider } from './providers/session/SessionProvider'
import { SystemProvider } from './providers/system/SystemProvider'
import { GuslThemeProvider } from './providers/theme/GuslThemeProvider'
import './static/css/App.css'
import './App.css'

import GlobalStyle from './styles/themes/globalStyle'

const container = document.getElementById('root')
const root = createRoot(container!)

root.render(
    <GuslThemeProvider>
        <GlobalStyle />
        <BrowserRouter>
            <Suspense fallback={<div>Loading...</div>}>
                <EnvironmentProvider>
                    <BlastProvider>
                        <SessionProvider>
                            <SystemProvider>
                                <Provider store={store}>
                                    <ScrollToTop />
                                    <AppWrapper />
                                </Provider>
                            </SystemProvider>
                        </SessionProvider>
                    </BlastProvider>
                </EnvironmentProvider>
            </Suspense>
        </BrowserRouter>
    </GuslThemeProvider>
)
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
